<!--
 * @Author: xiehangyi
 * @LastEditors: Hwc
 * @Description: 图片列表展示
-->
<template>
  <div class="lc-list-filter">
    <div class="lc-list-filter__row" v-if="filterLength <= 2">
      <div class="lc-list-filter__row-left">
        <!-- 筛选项表单 -->
        <slot></slot>
      </div>
      <div class="lc-list-filter__row-right">
        <!-- 操作按钮 -->
        <slot name="operation"></slot>
      </div>
    </div>
    <template v-else>
      <el-row
        type="flex"
        justify="space-between"
        :class="isCollapse ? 'lc-list-filter__collapse' : ''"
      >
        <slot></slot>
      </el-row>
      <el-row class="lc-list-filter__btn">
        <template v-if="filterLength > 3">
          <div
            class="lc-list-filter__collapse-txt"
            v-show="!isCollapse"
            @click="isCollapse = !isCollapse"
          >
            收起条件
            <svg-icon icon-class="icon-pack-up" />
          </div>
          <div
            class="lc-list-filter__collapse-txt"
            v-show="isCollapse"
            @click="isCollapse = !isCollapse"
          >
            展开条件({{ filterLength - 3 }})
            <svg-icon icon-class="icon-expansion" />
          </div>
        </template>
        <slot name="operation"></slot>
      </el-row>
    </template>
  </div>
</template>
<script>
export default {
  name: 'LcListFilter',
  props: {
    filterLength: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isCollapse: true
    }
  },
  created() {
    // preset
  },
  mounted() {
    // preset
  },
}
</script>
<style lang="scss">
.lc-list-filter__row {
  display: flex;
  flex-direction: row;
  &-left {
    min-width: 66.66%;
  }
  &-right {
    margin-left: auto;
    flex-shrink: 0;
    flex: 1;
    text-align: right;
    .lc-buttonGroup {
      padding: 0;
    }
  }
}
.lc-list-filter__btn {
  position: relative;
  margin-bottom: 20px;
}
.lc-list-filter__collapse {
  .el-form > :not(:first-child) {
    display: none;
  }
}
.lc-list-filter__collapse-txt {
  font-size: 14px;
  color: var(--primary-color);
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  line-height: 32px;
}
</style>